'use client'

import { useEffect } from 'react'
import { Text } from '@/design-system'
import { AuthCard } from './AuthCard'

type AuthMode = 'sign-in' | 'sign-up'

interface AuthModalProps {
  mode: AuthMode
  onClose: () => void
}

export function AuthModal({ mode, onClose }: AuthModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [onClose])

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        background: 'rgba(10, 10, 10, 0.55)'
      }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 420, position: 'relative' }}>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: -14,
            right: -14,
            zIndex: 2,
            width: 36,
            height: 36,
            border: 'var(--border-w) solid var(--ink)',
            background: 'var(--paper)',
            boxShadow: 'var(--shadow-sm)',
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center'
          }}>
          <Text as="span" variant="h4" weight={700} style={{ fontSize: 18 }}>
            ✕
          </Text>
        </button>
        <AuthCard initialMode={mode} />
      </div>
    </div>
  )
}
